// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4148":"09e1e1fd","14717":"ba71d164","22367":"e8bb6857","31846":"1fff3387","85399":"802a5d3e"}[chunkId] + ".css";
};